import React, { useEffect, useState } from "react";
import DataTables from "./components/DashboardTables";
import Edit from "./modals/Edit";
import View from "./modals/View";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Filter from "./modals/Filter";
import ChangePassword from "./modals/ChangePassword";
import Divider from "@material-ui/core/Divider/index";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import axios from "axios";
import { useSelector } from "react-redux";
import { updateObject } from "../../../helpers/updateObject";
import Log from "./modals/Log";

function Dashboard(props) {
  const token = useSelector((state) => state.auth.token);
  const [showLog, setShowLog] = useState(false);
  const [groups, setGroups] = useState([]);
  const [chooseGroupId, setChooseGroupId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteGroupsIds, setDeleteGroupsIds] = useState([]);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [filterInputs, setFilterInputs] = useState({
    email: "",
    middleName: "",
    name: "",
    surname: "",
    username: "",
    structureId: "",
    dutyId: "",
  });
  const toggleDrawer = (open) => (event) => {
    setShowView(open);
  };
  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onGroups = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
      email,
      middleName,
      name,
      surname,
      username,
      structureId,
      dutyId,
    } = filterInputs;
    setIsLoading(true);
    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }user?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${
          dutyId ? `&dutyId=${dutyId}` : ""
        }${email ? `&email=${email}` : ""}${
          middleName ? `&middleName=${middleName}` : ""
        }${name ? `&name=${name}` : ""}${surname ? `&surname=${surname}` : ""}${
          username ? `&username=${username}` : ""
        }${structureId ? `&structureId=${structureId}` : ""}`,
        {
          headers: { Authorization: `bearer ${token}` },
        }
      )
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
        // setShowFilter(false)
        setGroups(content);
        setIsError(false);
        setCount(totalElements);
      })
      .catch(() => {
        setIsLoading(false);
        setGroups([]);
        setIsError(true);
      });
  };

  const onGroupChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}user/${id}`, {
      headers: { Authorization: `bearer ${token}` },
    });
  };

  const onUpdateUserStatus = (id, status) => {
    let isActive =
      status === "ACTIVE" ? "INACTIVE" : status === "INACTIVE" && "ACTIVE";
    axios
      .put(
        `${process.env.REACT_APP_API_URL}user/status/${id}?status=${isActive}`
      )
      .then(() => {
        onGroups(orderBy, sortField, skip, take, filterInputs);
      });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onGroups(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);

  const [dutyId, setDutyId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}duty`)
      .then(({ data: { content } }) => {
        const duties = content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDutyId(duties);
      });
  }, []);

  const [structureId, setStructureId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}structure/select`)
      .then((res) => {
        const structureId = res.data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));
        setStructureId(structureId);
      });
  }, []);

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">İstifadəçilər</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <DataTables
        groups={groups}
        isLoading={isLoading}
        isError={isError}
        setChooseGroupId={setChooseGroupId}
        setOpenView={toggleDrawer(true)}
        setShowCreate={setShowCreate}
        setShowRemove={setShowRemove}
        setShowEdit={setShowEdit}
        setDeleteGroupsIds={setDeleteGroupsIds}
        deleteGroupsIds={deleteGroupsIds}
        setShowChangePassword={setShowChangePassword}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setShowLog={setShowLog}
        onUpdateUserStatus={onUpdateUserStatus}
      />
      {showCreate && (
        <Create
          show={showCreate}
          onHide={setShowCreate}
          onGroups={onGroups}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
          dutyId={dutyId}
          structureId={structureId}
        />
      )}

      {showView && (
        <View
          open={showView}
          onClose={toggleDrawer(false)}
          onGroupChoose={onGroupChoose}
          chooseGroupId={chooseGroupId}
        />
      )}

      {showRemove && (
        <Delete
          id={chooseGroupId}
          show={showRemove}
          onHide={setShowRemove}
          onGroups={onGroups}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
        />
      )}

      {showEdit && (
        <Edit
          show={showEdit}
          onHide={setShowEdit}
          onGroups={onGroups}
          chooseGroupId={chooseGroupId}
          onGroupChoose={onGroupChoose}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
          dutyId={dutyId}
          structureId={structureId}
        />
      )}

      <Log
        show={showLog}
        onHide={setShowLog}
        chooseGroupId={chooseGroupId}
        onGroupChoose={onGroupChoose}
        onGroups={onGroups}
        filterInputs={filterInputs}
        setChooseGroupId={setChooseGroupId}
      />
      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        structureId={structureId}
        dutyId={dutyId}
      />
      <ChangePassword
        show={showChangePassword}
        onHide={setShowChangePassword}
        id={chooseGroupId}
      />
    </div>
  );
}

export default Dashboard;
